import { Component, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { StateDto } from 'src/app/shared/models/location/state-dto';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';
import { DealershipDto, DealershipNoIdDto } from 'src/app/shared/models/dealership/dealership-dto';
import { CompanyFormComponent } from 'src/app/shared/components/forms/company-form/company-form.component';
import { DistributorDto } from 'src/app/shared/models/distributor/distributor-dto';
import { DistributorService } from 'src/app/shared/services/distributor/distributor.service';
import { Alert, AlertService } from '@michelin/theme';

@Component({
    selector: 'app-dealership-form',
    templateUrl: './dealership-form.component.html',
    standalone: false
})
export class DealershipFormComponent implements OnInit, AfterViewInit {
  loading = false;
  form: FormGroup = null;
  distributorDto: DistributorDto;

  @Input() readonly: boolean = false;
  @Input() automakers: AutomakerDto[] = [];
  @Input() states: StateDto[] = [];
  @Input() productLines: ProductLineDto[] = [];

  @ViewChild(CompanyFormComponent) companyForm: CompanyFormComponent;

  constructor(
    public readonly formBuilder: FormBuilder,
    public readonly distributorService: DistributorService,
    private readonly alertService: AlertService
  ) {
    this.form = this.formBuilder.group({
      automaker: ['', Validators.required],
      distributor: new FormControl({ value: '', disabled: true }),
      productLine: [''],
      code: ['', Validators.required],
      classification: [''],
      active: [true, Validators.required],
      deleted: [false, Validators.required]
      /** O componente <app-company-form/> vai adicionar o formGroup company */
    });
  }

  get automaker(): FormControl {
    return this.form.get('automaker') as FormControl;
  }

  get distributor(): FormControl {
    return this.form.get('distributor') as FormControl;
  }

  get productLine(): FormControl {
    return this.form.get('productLine') as FormControl;
  }

  get city(): FormControl {
    return this.form.get('company')?.get('address')?.get('city') as FormControl;
  }

  get formValues(): DealershipNoIdDto {
    return {
      code: this.form.value.code,
      classification: this.form.value.classification,
      status: this.form.value.active ? 'A' : 'I',
      deleted: this.form.value.deleted,
      productLineId: this.form.value.productLine?.id,
      automakerId: this.form.value.automaker?.id,
      company: this.companyForm?.formValues
    };
  }

  loadFormValues(data: DealershipDto) {
    this.form.patchValue({
      code: data.code,
      classification: data.classification,
      active: data.status == 'A' ? true : false,
      deleted: data.deleted,
      automaker: data.automaker,
      distributor: data.distributor?.company?.tradeName,
      productLine: data.productLine
    });
    this.companyForm.loadFormValues(data.company);
  }

  productLineDisplayName(data: ProductLineDto) {
    return data?.code || '';
  }

  companyDisplayName(data: AutomakerDto) {
    return data?.company?.tradeName || '';
  }

  ngOnInit() {
    if (this.readonly) {
      this.form.disable();
    }
  }

  ngAfterViewInit() {
    this.productLine.valueChanges.subscribe(() => {
      this.updateDistributor();
    });
    this.city.valueChanges.subscribe(() => {
      this.updateDistributor();
    });
  }

  updateDistributor() {
    if (this.city.value.id && this.productLine.value.id) {
      this.loading = true;
      this.distributorService
        .findByCityIdAndProductLine(this.city.value.id, this.productLine.value.id)
        .subscribe({
          next: (result) => this.distributor.setValue(result.company?.tradeName),
          error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao carregar o distribuidor' } as Alert)
        })
        .add(() => (this.loading = false));
    }
  }
}
